<nav class="navbar navbar-default">
	<div class="navbar-header">
		<img class="img-responsive" alt="Sofy" src="./assets/images/logoSofy.png">
	</div>
</nav>
